import { render, staticRenderFns } from "./AttributesInfo.vue?vue&type=template&id=7f9034ab&scoped=true"
import script from "./AttributesInfo.vue?vue&type=script&lang=js"
export * from "./AttributesInfo.vue?vue&type=script&lang=js"
import style0 from "./AttributesInfo.vue?vue&type=style&index=0&id=7f9034ab&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9034ab",
  null
  
)

export default component.exports